<template>
          <div class="gibson p4 fourthcolor-background center relative flex justify-center items-start" style="background-repeat:no-repeat;height:500px;background-position:left;background-image:url('../../static/img/banner-new-no-data.jpg?rotate=0&mode=crop');" >
              <div id="card">
                    <div class="card1">
                        <div class="items-center center "  >
                          <h2 class="white break-word line-height-2 mb1" style="font-size: 1rem;margin-bottom: .17rem;">Her arbejder {{ haaId }} </h2>
                          <h1 class="white break-word line-height-1 mb1" style="font-size:1.2rem;margin-bottom: .3rem;">Din lokale {{ companyPrimaryIndustryName  }} </h1>
                          <h1 class="break-word line-height-1 mintgreen mb1 " style="font-size: 1.5rem;margin-bottom: 0;">
                          {{ companyName }}
                          </h1>
                          <ul class="center white break-word regular" style="font-size: .9rem;">
                            <li><i class="el-icon-phone pr1"></i> <span> {{ companyTelephone }} </span></li>
                          </ul>
                          <h3 class="white " style="font-size: .6rem;margin-top: 0;margin-bottom: .5rem;">CVR: {{ companyCVR }} </h3>
                          <h2 class="white line-height-1 " style="font-size: 0.8rem;margin-bottom: 0;">Kunderne anbefaler os på Håndværker.dk</h2>
                          <div >
                            {{ companyRating }}
                          </div>
                        </div>
                    </div>
                    <div class="card2">
                        <div class="items-center center " >
                        <h2 class="darkblue break-word line-height-2 mb1" style="font-size: 1rem;margin-bottom: .17rem;">Her arbejder</h2>
                          <h1 class="darkblue break-word line-height-1 mb1" style="font-size:1.2rem;margin-bottom: .3rem;">Din lokale {{ companyPrimaryIndustryName }} </h1>
                          <h1 class="break-word line-height-1 mintgreen mb1 " style="font-size: 1.5rem;margin-bottom: 0;">
                          {{ companyName }}
                          </h1>
                          <ul class="center darkblue break-word regular" style="font-size: .9rem;">
                            <li><i class="el-icon-phone pr1"></i> <span> {{ companyTelephone }} </span></li>
                          </ul>
                          <h3 class="darkblue " style="font-size: .6rem;margin-top: 0;margin-bottom: .5rem;">CVR: {{ companyCVR }} </h3>
                          <h2 class="darkblue line-height-1 " style="font-size: 0.8rem;margin-bottom: 0;">Kunderne anbefaler os på Håndværker.dk</h2>
                          <div >
                             {{ companyRating }}
                          </div>
                        </div>
                      </div>
                      <div class="card3">
                        <div class="items-center center ">
                          <h1 class="darkblue break-word line-height-1 " style="font-size:.75rem;margin-bottom: .1rem;">Din lokale {{ companyPrimaryIndustryName }} </h1>
                          <h1 class="break-word line-height-1 mintgreen  " style="font-size: .9rem;margin-bottom: 0;">
                          {{ companyName }}
                          </h1>
                          <ul class="center darkblue break-word regular" style="font-size: .6rem;margin-bottom: 0;margin-top: 0;">
                            <li><i class="el-icon-phone pr1" style="margin-bottom: 0;"></i> <span> {{ companyTelephone }} </span></li>
                          </ul>
                          <h3 class="darkblue " style="font-size: .4rem;margin-top: 0;margin-bottom: .3rem;">CVR: {{ companyCVR }} </h3>
                          <h2 class="darkblue line-height-1 " style="font-size: 0.5rem;margin-bottom: 0;">Kunderne anbefaler os på Håndværker.dk</h2>
                          <div >
                            {{ companyRating }}
                          </div>
                        </div>
                      </div>
                      <div class="card4">
                        <div class="items-center center " >
                          <h1 class="white break-word line-height-1 " style="font-size:.75rem;margin-bottom: .1rem;"> {{ companyPrimaryIndustryName }} </h1>
                          <h1 class="break-word line-height-1 mintgreen  " style="font-size: .9rem;margin-bottom: 0;">
                          {{ companyName }}
                          </h1>
                          <ul class="center white break-word regular" style="font-size: .6rem;margin-bottom: 0;margin-top: 0;">
                           <li><i class="el-icon-phone pr1" style="margin-bottom: 0;"></i> <span>{{ companyTelephone }}</span></li>
                          </ul>
                          <h3 class="white " style="font-size: .4rem;margin-top: 0;margin-bottom: .3rem;">CVR: {{ companyCVR }} </h3>}
                          <h2 class="white line-height-1 " style="font-size: 0.5rem;margin-bottom: 0;">Kunderne anbefaler os på Håndværker.dk</h2>
                          <div >
                           {{ companyRating }}
                          </div>
                        </div>
                      </div>
                      <div class="card5">
                          <h2 class="white bold line-height-2" style="font-size: .45rem;">Kunderne anbefaler os på Håndværker.dk</h2>
                          <div class=" items-center justify-between" style="position:relative;">
                            <div class="" style="position:absolute;">
                              {{ companyName }}
                              </div>
                              <div class="left-align" style="float:right;position:absolute;padding-left: 64px;padding-top:5px;">
                            <p class="  white " style="font-size: .35rem;padding-bottom:0;" >Mere end {{ companyTotalRating }} anbefalinger</p>
                            <p class="  white " style="font-size: .35rem;padding-top :0;" >Over  {{ companyRating }} stjerner i gennemsnit</p>
                            </div>
                          </div>
                      </div>
                      <div class="card6">
                          <h2 class="darkblue bold line-height-2" style="font-size: .45rem;">Kunderne anbefaler os på Håndværker.dk</h2>
                          <div class=" items-center justify-between" style="position:relative;">
                            <div class="" style="position:absolute;">
                              {{ companyName }}
                              </div>
                              <div class="left-align" style="float:right;position:absolute;padding-left: 64px;padding-top:5px;">
                            <p class="  darkblue " style="font-size: .35rem;padding-bottom:0;" >Mere end {{ companyTotalRating }} anbefalinger</p>
                            <p class="  darkblue " style="font-size: .35rem;padding-top :0;" >Over  {{ companyRating }} stjerner i gennemsnit</p>
                            </div>
                          </div>
                      </div>
              </div>
          </div>
</template>
<script>
import axios from 'axios'
import WebshopHeader from './header'
export default{
  name: newFunction(),
  components: {
    WebshopHeader
  },
  data () {
    return {
      loading: true,
      info: null,
      companyPrimaryIndustryName: '',
      companyName: localStorage.getItem('CompanyName'),
      companyTelephone: '',
      companyCVR: '',
      companyRating: '',
      errored: null,
      haaId: localStorage.getItem('haaid')
    }
  },
  created () {
    this.getprofilebyid()
    this.getprofilebyids()
    this.haaId = localStorage.getItem('haaid')
    this.companyName = localStorage.getItem('Name')
  },
  mounted () {
    try {
      axios
        .get('http://webapi.haandvaerker.dk/v1/supplier/GetSupplierProfileById?id=' + this.haaId)
        .then((res) => {
          console.log('none')
          if (res.data.success === true) {
            var results = res.data.data[0]
            this.companyTelephone = results.data.data[0].Telephone
            this.companyPrimaryIndustryId = results.data.date[0].PrimaryIndustry
            this.companyCVR = res.data.data[0].Cvr
            this.companyRating = res.data.data[0].Ratingsummary.AverageRatingGrade
            this.sampleData = 'sdada'
            // this.companyName = res.data.data[0].Name
            // console.log(res.data.data[0].NAME)
            // this.showAlert()
          }
        })
        .catch(function () {
          console.log('Error')
        })
      axios
        .get('http://api.haandvaerker.dk/Industry/GetIndustrySelection/1')
        .then((res) => {
          console.log(res)
          // var stats = res.data
          this.companyPrimaryIndustryName = res.data[0].IndustryId
          // for (var i = 0; i < -1; i++) {
          //    this.discountValue = res.data[i].DISCOUNT_PRIC
          // }
          // console.log(this.companyPrimaryIndustryName)
        })
        .catch(function () {
          console.log('Error')
        })
    } catch (e) {
    }
  }
  // created () {
  //  fetch('http://webapi.haandvaerker.dk/v1/supplier/GetSupplierProfileById?id=40035')
  //    .then(response => response.json())
  //    .then(data => (this.profilepartner = data))
  // }
}
function newFunction () {
  return 'Createbannerwebshop'
}
</script>



<style>
#card {
  max-width: 100%;
  max-height: 100%;
  position: relative;
}
.card1{
  position: absolute;
  top: 6rem;
  right: 6em;
  width: 300px;
}
.card2{
  position:absolute;
  top: 8.60rem;
  left: 95em;
  width: 300px;
}
.card3{
  position:absolute;
  top: 18.7rem;
  left: 43.5em;
  width: 300px;
}
.card4{
  position:absolute;
  top: 18.8rem;
  left: 58em;
  width: 300px;
}
.card5{
  position:absolute;
  top: 16.3rem;
  left: 26.3em;
  width: 190px;
}
.card6{
  position:absolute;
  top: 15rem;
  left: 75.4em;
  width: 190px;
}
ul li {
    font-size: 1em;
    padding-left: 0;
    margin-top: .2rem;
    margin-bottom: .2rem;
}

.star2{
    background-size: 70%;
    background-repeat: no-repeat;
    background-position: center top;
}
.separate {
      width: 5.3%;
      padding: 13rem 0;
    }
    .separate-light {
      border-color: #fff;
      background-color: #fff;
    }
    .separate-dark {
      border-color: #003645;
      background-color: #003645;
    }
    .break-word {
      word-break: break-word;
    }
    .rating-container .rating-stars {
      pointer-events: none;
    }
    .rating-container .caption {
      display: none;
    }
    .rating-container .clear-rating {
      display: none;
    }
    .rating-container .empty-stars .star {
      opacity: 0.5;
    }
    .rating-container .glyphicon {
      visibility: hidden;
      line-height: 0;
    }
    .rating-container .star {
      margin: 0 0px;
    }
</style>


// WEBPACK FOOTER //
// Createbannerwebshop.vue?4635eb11